<template>
  <div class="screen screen__videos">
    <training-videos-listing
      :sm="8"
      :videos="videos">
    </training-videos-listing>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import training from '@/components/training';
  import TrainingVideosListing from '@/components/training/TrainingVideosListing.vue';

  export default {
    name: 'TrainingVideos',
    computed: {
      ...mapState(training.store.namespace, [
        'videos'
      ]),
    },
    components: {
      TrainingVideosListing
    }
  }
</script>

<style lang="scss" scoped>
  .screen {

    &__videos {
      background: #fafafa;
    }
  }
</style>
